import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, InnerWrapper } from './elements';
import Ico36 from 'dc/Ico36';
import { Typ31 } from 'dc/Typ';
import Spa08 from 'dc/Spa08';
import COLab01 from 'dc/COLab01';

function ChaMeta13(props) {
  return (
    <Wrapper className={props.className}>
      <Ico36
        icon={'icon-location_city'}
        size={'large1'}
        style={{
          marginRight: 16,
          color: props.isUserSection ? '#8bc34a' : '#90a4ae',
        }}
      />
      <InnerWrapper>
        <Typ31>
          {props.sectionName}
          <Spa08 />
        </Typ31>
        <COLab01
          points_text={props.points_text}
          activities_text={props.activities_text}
          participation_text={props.participation_text}
          tooltip_text={props.tooltip_text}
          expectedParticipants={props.expectedParticipants}
          participantCount={props.participantCount}
          percentValue={Number(
            (
              (props.participantCount / props.expectedParticipants) *
              100
            ).toFixed(0)
          )}
          progPercent={Number(
            (
              (props.participantCount / props.expectedParticipants) *
              100
            ).toFixed(0)
          )}
          type={'participants'}
        />
      </InnerWrapper>
    </Wrapper>
  );
}

ChaMeta13.propTypes = {
  points_text: PropTypes.string,
  activities_text: PropTypes.string,
  participation_text: PropTypes.string,
  tooltip_text: PropTypes.string,
  className: PropTypes.string,
  expectedParticipants: PropTypes.number,
  isUserSection: PropTypes.bool,
  participantCount: PropTypes.number,
  sectionName: PropTypes.string,
};

export default ChaMeta13;
